"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var REGISTER_ERRORS;
(function (REGISTER_ERRORS) {
    REGISTER_ERRORS["BAD_TOKEN"] = "BAD_TOKEN";
    REGISTER_ERRORS["BAD_DATA"] = "BAD_DATA";
    REGISTER_ERRORS["USER_ALREADY_EXISTS"] = "USER_ALREADY_EXISTS";
    REGISTER_ERRORS["NO_EMAIL"] = "NO_EMAIL";
})(REGISTER_ERRORS = exports.REGISTER_ERRORS || (exports.REGISTER_ERRORS = {}));
